"use client";

import { useEffect, useState } from "react";

const CONSENT_KEY = "prep5_cookie_consent";

const ALL_CONSENT_FIELDS = {
  analytics_storage: "granted",
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
};

const ALL_DENIED_FIELDS = {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
};

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let hasConsent = false;
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      hasConsent = stored === "granted" || stored === "denied";
    } catch (e) {
      // localStorage unavailable (SSR, private browsing, etc.)
    }
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "granted");
    } catch (e) {
      // localStorage unavailable
    }
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", ALL_CONSENT_FIELDS);
    }
    setIsVisible(false);
  };

  const handleDecline = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "denied");
    } catch (e) {
      // localStorage unavailable
    }
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", ALL_DENIED_FIELDS);
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">
          We use cookies to understand how you use Prep5 and improve your
          experience.{" "}
          <a
            href="/privacy-policy"
            className="underline text-blue-600 dark:text-blue-400"
          >
            Privacy Policy
          </a>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
